import { createDecorator } from '../../../../platform/instantiation/common/instantiation.js';
const IExternalUriOpenerService = ( createDecorator('externalUriOpenerService'));
export { IExternalUriOpenerService };
